export default __webpack_public_path__ + "static/media/average.f0a7e4bd.png";